import { useContext } from 'react'
import ArtboardTrimmer from '../../components/artboard-trimmer'
import { UgeArtboardContext } from '../../contexts/artboard'
import { UgeLayersContext } from '../../contexts/layers'
import { UgeEditorProps } from '../../types/editor'
import { Grid, Toolbar } from '../style'
import { NoLayers } from './style'

const DefaultEditor = ({ children }: UgeEditorProps) => {
    const { duration } = useContext(UgeArtboardContext)
    const { layers } = useContext(UgeLayersContext)

    return (
        <>
            <Toolbar>{duration > 0 && <ArtboardTrimmer />}</Toolbar>
            <Grid>
                {layers.length < 1 && <NoLayers />}
                {children}
            </Grid>
        </>
    )
}

export default DefaultEditor
